<script type="text/babel">
  import Base from './BaseChart.vue'

  export default Base.extend({
    name: "BaseMonodimentionalChart",
    methods: {
      buildDataset: function () {

        var backgroundColors = []
        var borderColors = []

        for (var counter = 0; counter < Object.keys(this.data).length; counter++) {

          var color = this.getColor(counter)

          backgroundColors.push(Chart.helpers.color(color).alpha(0.5).rgbString())
          borderColors.push(color)
        }

        return {
          labels: Object.keys(this.data),
          datasets: [
            {
              data: Object.values(this.data),
              backgroundColor: backgroundColors,
              borderColor: borderColors,
              fill: false,
            }
          ]
        }
      }
    }
  })
</script>



// WEBPACK FOOTER //
// BaseMonodimentionalChart.vue?f0296734